var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouting2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/routing-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "routing-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.64681 5.99967C4.93547 5.99967 5.98014 4.95501 5.98014 3.66634C5.98014 2.37768 4.93547 1.33301 3.64681 1.33301C2.35815 1.33301 1.31348 2.37768 1.31348 3.66634C1.31348 4.95501 2.35815 5.99967 3.64681 5.99967Z",
    stroke: "#707170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3138 10H13.3138C14.0471 10 14.6471 10.6 14.6471 11.3333V13.3333C14.6471 14.0667 14.0471 14.6667 13.3138 14.6667H11.3138C10.5805 14.6667 9.98047 14.0667 9.98047 13.3333V11.3333C9.98047 10.6 10.5805 10 11.3138 10Z",
    stroke: "#707170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.00013 3.33301H9.78679C11.0201 3.33301 11.5935 4.85967 10.6668 5.67301L5.34013 10.333C4.41346 11.1397 4.98679 12.6663 6.21346 12.6663H8.00013",
    stroke: "#707170",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.65748 3.66634H3.66518",
    stroke: "#707170",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.3245 12.3333H12.3322",
    stroke: "#707170",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouting2);
export default __webpack_public_path__ + "static/media/routing-2.8be48c4d.svg";
export { ForwardRef as ReactComponent };